<template>
<div class="table-container"> 
    <vs-card class="cardx">
                <div class="default-input d-flex align-items-center table-responsive filters-row">
            
            <label class="filter-label">Desde:</label>
            <input type="datetime-local" class="input_of_find" v-model="filters.startDateTime"/>
            
            <label class="filter-label ml-1">Hasta:</label>
            <input type="datetime-local" class="input_of_find" v-model="filters.endDateTime"/>

            <vs-button class="ps_rem_button ml-1" @click="fetchAlerts" color="darkgreen" type="border" icon="search"></vs-button>
        </div>
                
        <div class="alerts-scroll-area" v-if="alert.length > 0"> 
            <vs-table 
                :data="alert" 
                pagination 
                :max-items="8"
                search
            >
                <template slot="thead">
                  <vs-th>CAEX</vs-th>
                  <vs-th>Fecha y hora</vs-th>
                  <vs-th>Tipo de Alerta</vs-th>
                  <vs-th>Value</vs-th>
                  <vs-th>Imagen Miniatura</vs-th>
                </template>

                <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                  <vs-td :data="data[indextr].box_name">
                  {{data[indextr].box_name}}
                  </vs-td>
                  <vs-td :data="data[indextr].datetime">
                  {{data[indextr].datetime}}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                  {{data[indextr].type}}
                  </vs-td>
                  <vs-td :data="data[indextr].alert_json.distance">
                  {{data[indextr].alert_json.value}}
                  </vs-td>
                  <vs-td :data="data[indextr].alert_json.thumbnail">
                    <vs-button id="show-modal" @click="openThumbnailModal(data[indextr].alert_json.thumbnail)" color="primary" text-color="primary" size="small">Abrir magen miniatura</vs-button>
                  </vs-td>
                </vs-tr>
                </template>
            </vs-table>
        </div>

                <div v-else class="no_register_proximity">
            No existen registros.
        </div>
        
    </vs-card>
        <vs-popup title="Imagen Miniatura" :active.sync="showModal" class="dynamic-image-popup">
        <div class="image-popup-wrapper">
            <Thumbnails :img="activeThumbnailSrc" />
        </div>
    </vs-popup>
</div>
</template>

<script>
import axios from "axios";
import Thumbnails from "../utils/Thumbnails";

export default {
    name: "LastsxAlerts",
    props:{
        box_id: Number
    },
    components: {
        Thumbnails
    },
    data:()=>({
    filters: {
      startDateTime: '',
      endDateTime: '',
    },
    // ELIMINADO: bgClass (ya no se usará)
    showModal: false,
    showPopup: false,
    alert: [],
    activeThumbnailSrc: null
    }),
    methods:{
        getThumbnailSrc(base64Data) {
            if (base64Data && base64Data !== -1 && typeof base64Data === 'string' && base64Data.length > 50) {
                if (base64Data.startsWith('data:image/')) {
                    return base64Data;
                } else {
                    return `data:image/jpeg;base64,${base64Data}`;
                }
            }
            else {
                return require('@/assets/image_not_available.jpg');
            }
        },

        openThumbnailModal(base64Data) {
            this.activeThumbnailSrc = this.getThumbnailSrc(base64Data);
            this.showModal = true;
        },

        fetchAlerts(){
            const url_api = this.$store.state.url_api;
            const params = { box_id: this.box_id };

            if (this.filters.startDateTime) {
                params.start_date = this.filters.startDateTime.replace('T', ' ');
            }

            if (this.filters.endDateTime) {
                params.end_date = this.filters.endDateTime.replace('T', ' ');
            }
            
            this.$vs.loading();
            
            axios.get(url_api + 'base/lastxalertByDate', { params })
                .then(response => {
                    this.alert = response.data;
                    this.showPopup = true; // Mantener notificación "Listo!"
                })
                .catch((error) => {
                    console.error("Error al obtener alertas:", error);
                    this.$vs.notify({ title: 'Error', text: 'Fallo al cargar alertas.', color: 'danger' });
                    this.alert = [];
                })
                .finally(() => {
                    this.$vs.loading.close();
                });
        },
    },
    mounted(){
        this.fetchAlerts();
    },
    watch: {
        showPopup(newVal) {
            if (newVal) {
                // ELIMINADO: this.bgClass = 'bg-ok-proximity-active';
                setTimeout(() => {
                    this.showPopup = false;
                    // ELIMINADO: this.bgClass = 'bg-ok-proximity';
                }, 2000);
            }
        },
    },
}
</script>
<style scoped>
/* --- ESTILOS GENERALES Y DE FILTROS --- */
.alerts-scroll-area {
    max-height: 100%;
    flex-grow: 1;
    overflow-y: auto;
    padding: 0 10px;
    margin-top: 15px;
}
.mb-4 {
    margin-bottom: 1.5rem;
}

/* Estilos de la fila de filtros */
.filters-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}
.filter-label {
    font-weight: bold;
    margin-left: 10px;
    margin-right: 5px;
    color: #333;
    white-space: nowrap;
}
.input_of_find {
    padding: 8px;
    border-radius: 5px;
    border: 1px solid #ccc;
    background-color: #fff;
    flex-grow: 1;
    min-width: 150px;
}
.ml-1 {
    margin-left: 1rem;
}

.popup_proximity{
    background-color: darkgreen;
    color: white;
    margin-top: 26px;
    font-size: 16px;
    margin-left: 1em;
    width: 4em;
    text-align: center;
    border-radius: 13%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 3.5);
}
.no_register_proximity{
    font-weight: bold;
    font-size: 14px;
    text-align: center;
}
/* ELIMINADO: .bg-ok-proximity-active */
/* ELIMINADO: .bg-ok-proximity */
.ps_rem_button{
  width: 70px;
  height: 35px;
}
.cardx {
    height: 100%;
    display: flex;
    flex-direction: column;
}

/* --- SOLUCIÓN PARA EL ANCHO FIJO DE MINIATURA (DYNAMIC IMAGE POPUP) --- */
.dynamic-image-popup /deep/ .vs-popup {
    width: 250px !important;
    max-width: 250px !important;
    min-width: 250px !important;
    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, .1) !important;
}

.dynamic-image-popup /deep/ .vs-popup--content {
    padding: 0;
    width: 100% !important;
    height: 100% !important;
    min-height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.image-popup-wrapper {
    width: 200px;
    height: 200px;
}

.imgAlert {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
}
</style>